function GuestType() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestType</div>
      </>
    );
  }
  
  export default GuestType;